export default {
	searchParams: {
		cpnyCd: '',
		useYn: '',
		cpnyScn: '' //(10:생산업체, 20:납품업체, 90:htwo)
	},
	pqyCpnyList: [],
	pagingInfo: {
		currentPage: 1,
		endPage: 1,
		pageUnit: 30,
		startPage: 1,
		totalSize: 1
	},

	deptList: []
};
